// import React from 'react';
// import { motion } from 'motion/react';
// import { ArrowRight, Play, Sparkles, CreditCard, QrCode } from 'lucide-react';

// export function Hero() {
//   return (
//     <section className="relative min-h-screen flex items-center justify-center pt-20 px-4 sm:px-6 lg:px-20 overflow-hidden">
//       {/* Background Gradient */}
//       <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-accent/5 to-transparent dark:from-primary/10 dark:via-accent/10" />

//       {/* Animated Background Elements */}
//       <motion.div
//         className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl"
//         animate={{
//           scale: [1, 1.2, 1],
//           opacity: [0.3, 0.5, 0.3],
//         }}
//         transition={{ duration: 8, repeat: Infinity }}
//       />
//       <motion.div
//         className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl"
//         animate={{
//           scale: [1.2, 1, 1.2],
//           opacity: [0.5, 0.3, 0.5],
//         }}
//         transition={{ duration: 10, repeat: Infinity }}
//       />

//       <div className="relative max-w-7xl mx-auto w-full">
//         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
//           {/* Left Content */}
//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8, delay: 0.2 }}
//             className="text-center lg:text-left"
//           >
//             {/* Badge */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.3 }}
//               className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary/10 to-accent/10 rounded-full mb-6 border border-primary/20"
//             >
//               <Sparkles className="w-4 h-4 text-primary" />
//               <span className="text-sm font-medium text-primary">Next-Gen Business Cards</span>
//             </motion.div>

//             {/* Headline */}
//             <motion.h1
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.4 }}
//               className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6"
//             >
//               Revolutionize Your Experience with{' '}
//               <span className="bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent">
//                 Smart NFC Cards
//               </span>
//               <br />
//               <span className="text-3xl sm:text-4xl lg:text-5xl">Custom Designs for Every Need</span>
//             </motion.h1>

//             {/* Subtext */}
//             <motion.p
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.5 }}
//               className="text-lg lg:text-xl text-muted-foreground mb-8 max-w-xl mx-auto lg:mx-0"
//             >
//               Welcome to the future of connectivity with our cutting-edge NFC card designs. 
//               Our NFC cards combine sleek aesthetics with advanced technology to deliver a seamless, modern experience.
//             </motion.p>

//             {/* CTAs */}
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.6 }}
//               className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
//             >
//               <motion.button
//                 className="group px-8 py-4 bg-gradient-to-r from-primary to-accent text-white rounded-xl font-semibold shadow-lg hover:shadow-2xl hover:shadow-primary/50 dark:hover:shadow-primary/30 transition-all duration-300 flex items-center justify-center gap-2"
//                 whileHover={{ scale: 1.05, y: -2 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 Get Started
//                 <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
//               </motion.button>

//               <motion.button
//                 className="group px-8 py-4 bg-card border-2 border-border hover:border-primary text-foreground rounded-xl font-semibold shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
//                 whileHover={{ scale: 1.05, y: -2 }}
//                 whileTap={{ scale: 0.95 }}
//               >
//                 View Designs
//               </motion.button>
//             </motion.div>
//           </motion.div>

//           {/* Right Visual */}
//           <motion.div
//             initial={{ opacity: 0, x: 50 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8, delay: 0.4 }}
//             className="relative"
//           >
//             <div className="relative z-10">
//               {/* Main Card */}
//               <motion.div
//                 initial={{ opacity: 0, y: 40 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.6 }}
//                 className="relative bg-gradient-to-br from-card to-muted p-8 rounded-2xl shadow-2xl border border-border backdrop-blur-sm"
//                 whileHover={{ scale: 1.02, rotateY: 5 }}
//                 style={{ transformStyle: 'preserve-3d' }}
//               >
//                 <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl opacity-0 hover:opacity-100 transition-opacity duration-300" />
//                 <div className="relative space-y-4">
//                   <div className="flex items-center gap-4">
//                     <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-accent" />
//                     <div>
//                       <h3 className="font-bold text-lg text-foreground">John Anderson</h3>
//                       <p className="text-muted-foreground">Product Designer</p>
//                     </div>
//                   </div>
//                   <div className="h-px bg-border" />
//                   <div className="space-y-2 text-sm text-muted-foreground">
//                     <p>📧 john@company.com</p>
//                     <p>📱 +1 (555) 123-4567</p>
//                     <p>🌐 johnanderson.com</p>
//                   </div>
//                 </div>
//               </motion.div>

//               {/* Floating Elements */}
//               <motion.div
//                 className="absolute -top-6 -right-6 p-4 bg-card rounded-xl shadow-lg border border-border"
//                 animate={{
//                   y: [0, -10, 0],
//                 }}
//                 transition={{ duration: 3, repeat: Infinity }}
//               >
//                 <CreditCard className="w-8 h-8 text-primary" />
//               </motion.div>

//               <motion.div
//                 className="absolute -bottom-6 -left-6 p-4 bg-card rounded-xl shadow-lg border border-border"
//                 animate={{
//                   y: [0, 10, 0],
//                 }}
//                 transition={{ duration: 3.5, repeat: Infinity }}
//               >
//                 <QrCode className="w-8 h-8 text-accent" />
//               </motion.div>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }









import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles, CreditCard, QrCode } from "lucide-react";

const Hero = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "80px",
        paddingLeft: "16px",
        paddingRight: "16px",
        overflow: "hidden",
      }}
    >
      {/* Background Gradient */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom right, rgba(99,102,241,0.05), rgba(34,211,238,0.05), transparent)",
        }}
      />

      {/* Animated Background Elements */}
      <motion.div
        style={{
          position: "absolute",
          top: "80px",
          left: "40px",
          width: "288px",
          height: "288px",
          backgroundColor: "rgba(99,102,241,0.2)",
          borderRadius: "9999px",
          filter: "blur(48px)",
        }}
        animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
        transition={{ duration: 8, repeat: Infinity }}
      />

      <motion.div
        style={{
          position: "absolute",
          bottom: "80px",
          right: "40px",
          width: "384px",
          height: "384px",
          backgroundColor: "rgba(34,211,238,0.2)",
          borderRadius: "9999px",
          filter: "blur(48px)",
        }}
        animate={{ scale: [1.2, 1, 1.2], opacity: [0.5, 0.3, 0.5] }}
        transition={{ duration: 10, repeat: Infinity }}
      />

      <div
        style={{
          position: "relative",
          maxWidth: "1120px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        {/* Responsive Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
            gap: "48px",
            alignItems: "center",
          }}
        >
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            style={{ textAlign: isDesktop ? "left" : "center" }}
          >
            {/* Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 16px",
                background:
                  "linear-gradient(to right, rgba(99,102,241,0.1), rgba(34,211,238,0.1))",
                borderRadius: "9999px",
                marginBottom: "24px",
                border: "1px solid rgba(99,102,241,0.2)",
              }}
            >
              <Sparkles style={{ width: "16px", height: "16px", color: "#6366f1" }} />
              <span style={{ fontSize: "0.875rem", fontWeight: 500, color: "#6366f1" }}>
                Next-Gen Business Cards
              </span>
            </motion.div>

            {/* Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              style={{
                fontSize: isDesktop ? "3rem" : "2.5rem",
                fontWeight: "bold",
                color: "#111",
                lineHeight: 1.2,
                marginBottom: "24px",
              }}
            >
              Revolutionize Your Experience with{" "}
              <span
                style={{
                  background: "linear-gradient(to right, #6366f1, #22d3ee, #facc15)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Smart NFC Cards
              </span>
              <br />
              <span style={{ fontSize: isDesktop ? "2rem" : "1.5rem" }}>
                Custom Designs for Every Need
              </span>
            </motion.h1>

            {/* Subtext */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              style={{
                fontSize: "1.125rem",
                color: "#6b7280",
                marginBottom: "32px",
                maxWidth: "480px",
                marginLeft: isDesktop ? "0" : "auto",
                marginRight: isDesktop ? "0" : "auto",
              }}
            >
              Welcome to the future of connectivity with our cutting-edge NFC card designs.
              Our NFC cards combine sleek aesthetics with advanced technology to deliver a seamless, modern experience.
            </motion.p>

            {/* CTAs */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              style={{
                display: "flex",
                flexDirection: isDesktop ? "row" : "column",
                gap: "16px",
                justifyContent: isDesktop ? "flex-start" : "center",
              }}
            >
              <motion.button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px 32px",
                  background: "linear-gradient(to right, #6366f1, #22d3ee)",
                  color: "#fff",
                  borderRadius: "16px",
                  fontWeight: 600,
                  cursor: "pointer",
                  border: "none",
                }}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                Get Started
                <ArrowRight style={{ width: "20px", height: "20px" }} />
              </motion.button>

              <motion.button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px 32px",
                  background: "#fff",
                  border: "2px solid #e5e7eb",
                  color: "#111",
                  borderRadius: "16px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
              >
                View Designs
              </motion.button>
            </motion.div>
          </motion.div>

          {/* Right Card */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            style={{ position: "relative" }}
          >
            <div style={{ position: "relative", zIndex: 10 }}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                whileHover={{ scale: 1.02, rotateY: 5 }}
                style={{
                  position: "relative",
                  background: "linear-gradient(to bottom right, #fff, #f3f4f6)",
                  padding: "32px",
                  borderRadius: "24px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                  border: "1px solid #e5e7eb",
                  transformStyle: "preserve-3d",
                  margin: isDesktop ? 0 : "0 auto", // center on mobile
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(to bottom right, rgba(99,102,241,0.1), rgba(34,211,238,0.1))",
                    borderRadius: "24px",
                    opacity: 0,
                    transition: "opacity 0.3s",
                  }}
                />
                <div
                  style={{ position: "relative", display: "flex", flexDirection: "column", gap: "16px" }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <div
                      style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "9999px",
                        background: "linear-gradient(to bottom right, #6366f1, #22d3ee)",
                      }}
                    />
                    <div>
                      <h3 style={{ fontWeight: "bold", fontSize: "1.125rem", color: "#111" }}>
                        John Anderson
                      </h3>
                      <p style={{ color: "#6b7280" }}>Product Designer</p>
                    </div>
                  </div>
                  <div style={{ height: "1px", backgroundColor: "#e5e7eb" }} />
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "0.875rem", color: "#6b7280" }}>
                    <p>📧 john@company.com</p>
                    <p>📱 +1 (555) 123-4567</p>
                    <p>🌐 johnanderson.com</p>
                  </div>
                </div>
              </motion.div>

              {/* Floating Elements */}
              <motion.div
                style={{
                  position: "absolute",
                  top: "-24px",
                  right: "-24px",
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                  border: "1px solid #e5e7eb",
                }}
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
              >
                <CreditCard style={{ width: "32px", height: "32px", color: "#6366f1" }} />
              </motion.div>

              <motion.div
                style={{
                  position: "absolute",
                  bottom: "-24px",
                  left: "-24px",
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
                  border: "1px solid #e5e7eb",
                }}
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 3.5, repeat: Infinity }}
              >
                <QrCode style={{ width: "32px", height: "32px", color: "#22d3ee" }} />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

